var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-main-content" },
    [
      _c("div", { staticClass: "grid-view" }, [
        _c(
          "div",
          { staticClass: "main-content" },
          [
            _c("div", { staticClass: "operations" }, [
              _c("div", { staticClass: "triggers" }, [
                _c(
                  "div",
                  { staticClass: "edi-triggers" },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "query-toggle",
                        on: {
                          click: function($event) {
                            _vm.expandSearchForm = !_vm.expandSearchForm
                          }
                        }
                      },
                      [
                        _c("i", {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: !_vm.expandSearchForm,
                              expression: "!expandSearchForm"
                            }
                          ],
                          staticClass: "el-icon-arrow-left down"
                        }),
                        _c("i", {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.expandSearchForm,
                              expression: "expandSearchForm"
                            }
                          ],
                          staticClass: "el-icon-arrow-left up"
                        })
                      ]
                    ),
                    _c("el-input", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.expandSearchForm,
                          expression: "!expandSearchForm"
                        }
                      ],
                      attrs: { placeholder: _vm.$t("SeaExport.Prompt1") },
                      model: {
                        value: _vm.searchConditions.jobNo,
                        callback: function($$v) {
                          _vm.$set(_vm.searchConditions, "jobNo", $$v)
                        },
                        expression: "searchConditions.jobNo"
                      }
                    }),
                    _c(
                      "el-menu",
                      {
                        attrs: {
                          mode: "horizontal",
                          "active-text-color": "#909399"
                        },
                        on: { select: _vm.onMenuSelect }
                      },
                      [
                        _c(
                          "el-menu-item",
                          { attrs: { index: "query" } },
                          [
                            _c(
                              "template",
                              { slot: "title" },
                              [
                                _c(
                                  "el-button",
                                  { attrs: { no: "1", type: "primary" } },
                                  [_vm._v(_vm._s(_vm.$t("common.btn.query")))]
                                )
                              ],
                              1
                            )
                          ],
                          2
                        ),
                        _c(
                          "el-menu-item",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.expandSearchForm,
                                expression: "expandSearchForm"
                              }
                            ],
                            attrs: { index: "reset" }
                          },
                          [
                            _c(
                              "template",
                              { slot: "title" },
                              [
                                _c(
                                  "el-button",
                                  { attrs: { no: "2", type: "warning" } },
                                  [_vm._v(_vm._s(_vm.$t("common.btn.reset")))]
                                )
                              ],
                              1
                            )
                          ],
                          2
                        ),
                        _c(
                          "el-submenu",
                          { attrs: { index: "booking" } },
                          [
                            _c(
                              "template",
                              { slot: "title" },
                              [
                                _c(
                                  "el-button-group",
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          no: "3",
                                          type: "primary",
                                          size: "small"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$t("SeaExport.Booking"))
                                        )
                                      ]
                                    ),
                                    _c(
                                      "el-button",
                                      {
                                        staticClass: "attach-caret-button",
                                        attrs: { no: "4", type: "primary" }
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "el-icon-arrow-down"
                                        })
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm.oneKeyBookingEnable &&
                            _vm.$checkPermission(["button_EDI_oneKeyBooking"])
                              ? _c(
                                  "el-menu-item",
                                  { attrs: { index: "oneKeyBooking" } },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("CargoMsg.Cargo_OneKeyBooking")
                                      )
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _c(
                              "el-submenu",
                              { attrs: { index: "origin" } },
                              [
                                _c("template", { slot: "title" }, [
                                  _vm._v(_vm._s(_vm.$t("SeaExport.Original")))
                                ]),
                                _c(
                                  "el-menu-item",
                                  {
                                    attrs: {
                                      no: "5",
                                      index: "API",
                                      disabled:
                                        !_vm.btnStatus.bookingBtn ||
                                        (!(
                                          _vm.configMap.get(
                                            "BookingEDIApiOpen"
                                          ) !== "0"
                                        ) &&
                                          !_vm.isHZ)
                                    }
                                  },
                                  [_vm._v("API")]
                                ),
                                _c(
                                  "el-menu-item",
                                  {
                                    attrs: {
                                      no: "6",
                                      index: "FTP",
                                      disabled:
                                        !_vm.btnStatus.bookingBtn || _vm.isHZ
                                    }
                                  },
                                  [_vm._v("FTP")]
                                ),
                                _c(
                                  "el-menu-item",
                                  {
                                    attrs: {
                                      no: "rpa1",
                                      index: "RPA1",
                                      disabled:
                                        !_vm.btnStatus.bookingBtn || _vm.isHZ
                                    }
                                  },
                                  [_vm._v("RPA")]
                                )
                              ],
                              2
                            ),
                            _c(
                              "el-submenu",
                              { attrs: { index: "correct" } },
                              [
                                _c("template", { slot: "title" }, [
                                  _vm._v(_vm._s(_vm.$t("SeaExport.Correct")))
                                ]),
                                _c(
                                  "el-menu-item",
                                  {
                                    attrs: {
                                      no: "7",
                                      index: "FTP",
                                      disabled:
                                        !_vm.btnStatus.bookingBtn || _vm.isHZ
                                    }
                                  },
                                  [_vm._v("FTP")]
                                ),
                                _c(
                                  "el-menu-item",
                                  {
                                    attrs: {
                                      no: "8",
                                      index: "API",
                                      disabled:
                                        !_vm.btnStatus.bookingBtn ||
                                        !(
                                          _vm.configMap.get(
                                            "BookingEDIApiOpen"
                                          ) !== "0"
                                        ) ||
                                        _vm.isHZ
                                    }
                                  },
                                  [_vm._v("API")]
                                )
                              ],
                              2
                            ),
                            _c(
                              "el-menu-item",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value:
                                      _vm.configMap.get(
                                        "SEAllowReceiptImport"
                                      ) === "1",
                                    expression:
                                      "configMap.get('SEAllowReceiptImport') === '1'"
                                  }
                                ],
                                attrs: {
                                  no: "9",
                                  index: "import",
                                  disabled: !_vm.btnStatus.bookingBtn
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("SeaExport.ReceiptImport"))
                                )
                              ]
                            )
                          ],
                          2
                        ),
                        _c(
                          "el-submenu",
                          {
                            directives: [
                              {
                                name: "permission",
                                rawName: "v-permission",
                                value: ["button_EDI_billOfLading"],
                                expression: "['button_EDI_billOfLading']"
                              }
                            ],
                            attrs: {
                              index: "bl",
                              disabled: !_vm.btnStatus.blBtn
                            }
                          },
                          [
                            _c(
                              "template",
                              { slot: "title" },
                              [
                                _c(
                                  "el-button-group",
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          no: "10",
                                          type: "primary",
                                          size: "small"
                                        }
                                      },
                                      [_vm._v(_vm._s(_vm.$t("SeaExport.Bl")))]
                                    ),
                                    _c(
                                      "el-button",
                                      {
                                        staticClass: "attach-caret-button",
                                        attrs: { no: "11", type: "primary" }
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "el-icon-arrow-down"
                                        })
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _c(
                              "el-submenu",
                              { attrs: { index: "origin" } },
                              [
                                _c("template", { slot: "title" }, [
                                  _vm._v(_vm._s(_vm.$t("SeaExport.Original")))
                                ]),
                                _c(
                                  "el-menu-item",
                                  {
                                    attrs: {
                                      no: "12",
                                      index: "API",
                                      disabled: !(
                                        _vm.configMap.get("BillEDIApiOpen") !==
                                        "0"
                                      )
                                    }
                                  },
                                  [_vm._v("API")]
                                ),
                                _c(
                                  "el-menu-item",
                                  { attrs: { no: "13", index: "FTP" } },
                                  [_vm._v("FTP")]
                                )
                              ],
                              2
                            ),
                            _c(
                              "el-submenu",
                              { attrs: { index: "correct" } },
                              [
                                _c("template", { slot: "title" }, [
                                  _vm._v(_vm._s(_vm.$t("SeaExport.Correct")))
                                ]),
                                _c(
                                  "el-menu-item",
                                  { attrs: { no: "14", index: "FTP" } },
                                  [_vm._v("FTP")]
                                ),
                                _c(
                                  "el-menu-item",
                                  {
                                    attrs: {
                                      no: "15",
                                      index: "API",
                                      disabled: !(
                                        _vm.configMap.get("BillEDIApiOpen") !==
                                        "0"
                                      )
                                    }
                                  },
                                  [_vm._v("API")]
                                )
                              ],
                              2
                            ),
                            _c(
                              "el-menu-item",
                              {
                                attrs: {
                                  no: "CargoDocExtend",
                                  index: "CargoDocExtend"
                                }
                              },
                              [_vm._v(_vm._s(_vm.$t("SeaExport.EdiEuBolInfo")))]
                            )
                          ],
                          2
                        ),
                        _c(
                          "el-submenu",
                          {
                            attrs: {
                              index: "vgm",
                              disabled: !_vm.btnStatus.vgmBtn
                            }
                          },
                          [
                            _c(
                              "template",
                              { slot: "title" },
                              [
                                _c(
                                  "el-button-group",
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          no: "16",
                                          type: "primary",
                                          size: "small"
                                        }
                                      },
                                      [_vm._v("VGM")]
                                    ),
                                    _c(
                                      "el-button",
                                      {
                                        staticClass: "attach-caret-button",
                                        attrs: { no: "17", type: "primary" }
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "el-icon-arrow-down"
                                        })
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _c(
                              "el-menu-item",
                              { attrs: { no: "18", index: "origin" } },
                              [_vm._v(_vm._s(_vm.$t("SeaExport.Original")))]
                            ),
                            _c(
                              "el-menu-item",
                              { attrs: { no: "19", index: "correct" } },
                              [_vm._v(_vm._s(_vm.$t("SeaExport.Correct")))]
                            )
                          ],
                          2
                        ),
                        _c(
                          "el-submenu",
                          { attrs: { index: "sham" } },
                          [
                            _c(
                              "template",
                              { slot: "title" },
                              [
                                _c(
                                  "el-button-group",
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        staticStyle: { width: "160px" },
                                        attrs: {
                                          no: "20",
                                          type: "primary",
                                          size: "small"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("SeaExport.OverseasAgeFore")
                                          )
                                        )
                                      ]
                                    ),
                                    _c(
                                      "el-button",
                                      {
                                        staticClass: "attach-caret-button",
                                        attrs: { no: "21", type: "primary" }
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "el-icon-arrow-down"
                                        })
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _c(
                              "el-menu-item",
                              { attrs: { no: "22", index: "overseaAgent" } },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("SeaExport.OverseasAgeFore"))
                                )
                              ]
                            ),
                            _c(
                              "el-menu-item",
                              { attrs: { no: "23", index: "cargoWise" } },
                              [_vm._v("CargoWise")]
                            ),
                            _c(
                              "el-submenu",
                              { attrs: { index: "jinYi" } },
                              [
                                _c("template", { slot: "title" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("SeaExport.JingyiSystemForecast")
                                    )
                                  )
                                ]),
                                _c(
                                  "el-menu-item",
                                  { attrs: { no: "24", index: "origin" } },
                                  [_vm._v(_vm._s(_vm.$t("SeaExport.Original")))]
                                ),
                                _c(
                                  "el-menu-item",
                                  { attrs: { no: "25", index: "correct" } },
                                  [_vm._v(_vm._s(_vm.$t("SeaExport.Correct")))]
                                ),
                                _c(
                                  "el-menu-item",
                                  { attrs: { no: "26", index: "delete" } },
                                  [_vm._v(_vm._s(_vm.$t("FileHistory.Delete")))]
                                )
                              ],
                              2
                            ),
                            _c(
                              "el-submenu",
                              {
                                directives: [
                                  {
                                    name: "permission",
                                    rawName: "v-permission",
                                    value: ["button_EDI_overseasAgentForecast"],
                                    expression:
                                      "['button_EDI_overseasAgentForecast']"
                                  }
                                ],
                                attrs: { index: "jcl" }
                              },
                              [
                                _c("template", { slot: "title" }, [
                                  _vm._v(
                                    _vm._s(_vm.$t("SeaExport.JclForecast"))
                                  )
                                ]),
                                _c(
                                  "el-menu-item",
                                  {
                                    attrs: {
                                      no: "JclOriginal",
                                      index: "origin"
                                    }
                                  },
                                  [_vm._v(_vm._s(_vm.$t("SeaExport.Original")))]
                                ),
                                _c(
                                  "el-menu-item",
                                  {
                                    attrs: {
                                      no: "JclCorrect",
                                      index: "correct"
                                    }
                                  },
                                  [_vm._v(_vm._s(_vm.$t("SeaExport.Correct")))]
                                ),
                                _c(
                                  "el-menu-item",
                                  {
                                    attrs: { no: "JclDelete", index: "delete" }
                                  },
                                  [_vm._v(_vm._s(_vm.$t("FileHistory.Delete")))]
                                )
                              ],
                              2
                            )
                          ],
                          2
                        ),
                        _c(
                          "el-submenu",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value:
                                  _vm.configMap.get("ToExoSystem") === "XY",
                                expression:
                                  "configMap.get('ToExoSystem') === 'XY'"
                              }
                            ],
                            attrs: {
                              index: "E2Open",
                              disabled: !_vm.btnStatus.xyE2OpenBtn
                            }
                          },
                          [
                            _c(
                              "template",
                              { slot: "title" },
                              [
                                _c(
                                  "el-button-group",
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          no: "27",
                                          type: "primary",
                                          size: "small"
                                        }
                                      },
                                      [_vm._v("E2Open")]
                                    ),
                                    _c(
                                      "el-button",
                                      {
                                        staticClass: "attach-caret-button",
                                        attrs: { no: "28", type: "primary" }
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "el-icon-arrow-down"
                                        })
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _c(
                              "el-submenu",
                              { attrs: { index: "origin" } },
                              [
                                _c("template", { slot: "title" }, [
                                  _vm._v(_vm._s(_vm.$t("SeaExport.Original")))
                                ]),
                                _c(
                                  "el-submenu",
                                  { attrs: { index: "856" } },
                                  [
                                    _c("template", { slot: "title" }, [
                                      _vm._v(
                                        "856" +
                                          _vm._s(_vm.$t("SeaExport.Message"))
                                      )
                                    ]),
                                    _c(
                                      "el-menu-item",
                                      { attrs: { no: "29", index: "LTO" } },
                                      [_vm._v("LTO")]
                                    ),
                                    _c(
                                      "el-menu-item",
                                      { attrs: { no: "30", index: "CLP" } },
                                      [_vm._v("CLP")]
                                    )
                                  ],
                                  2
                                ),
                                _c(
                                  "el-submenu",
                                  { attrs: { index: "315" } },
                                  [
                                    _c("template", { slot: "title" }, [
                                      _vm._v(
                                        "315" +
                                          _vm._s(_vm.$t("SeaExport.Message"))
                                      )
                                    ]),
                                    _c(
                                      "el-menu-item",
                                      {
                                        attrs: {
                                          no: "origin-315-EE",
                                          index: "315EE"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$t("SeaExport.EmptyOut"))
                                        )
                                      ]
                                    ),
                                    _c(
                                      "el-menu-item",
                                      {
                                        attrs: {
                                          no: "origin-315-I",
                                          index: "315I"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$t("SeaExport.GateIn"))
                                        )
                                      ]
                                    ),
                                    _c(
                                      "el-menu-item",
                                      {
                                        attrs: {
                                          no: "origin-315-VD",
                                          index: "315VD"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "SeaExport.VesselDeparturePOL"
                                            )
                                          )
                                        )
                                      ]
                                    ),
                                    _c(
                                      "el-menu-item",
                                      {
                                        attrs: {
                                          no: "origin-315-ALL",
                                          index: "315ALL"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$t("SeaExport.SendAll"))
                                        )
                                      ]
                                    )
                                  ],
                                  2
                                )
                              ],
                              2
                            ),
                            _c(
                              "el-submenu",
                              { attrs: { index: "correct" } },
                              [
                                _c("template", { slot: "title" }, [
                                  _vm._v(_vm._s(_vm.$t("SeaExport.Correct")))
                                ]),
                                _c(
                                  "el-submenu",
                                  { attrs: { index: "856" } },
                                  [
                                    _c("template", { slot: "title" }, [
                                      _vm._v(
                                        "856" +
                                          _vm._s(_vm.$t("SeaExport.Message"))
                                      )
                                    ]),
                                    _c(
                                      "el-menu-item",
                                      { attrs: { no: "32", index: "LTO" } },
                                      [_vm._v("LTO")]
                                    ),
                                    _c(
                                      "el-menu-item",
                                      { attrs: { no: "33", index: "CLP" } },
                                      [_vm._v("CLP")]
                                    )
                                  ],
                                  2
                                ),
                                _c(
                                  "el-submenu",
                                  { attrs: { index: "315" } },
                                  [
                                    _c("template", { slot: "title" }, [
                                      _vm._v(
                                        "315" +
                                          _vm._s(_vm.$t("SeaExport.Message"))
                                      )
                                    ]),
                                    _c(
                                      "el-menu-item",
                                      {
                                        attrs: {
                                          no: "correct-315-EE",
                                          index: "315EE"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$t("SeaExport.EmptyOut"))
                                        )
                                      ]
                                    ),
                                    _c(
                                      "el-menu-item",
                                      {
                                        attrs: {
                                          no: "correct-315-I",
                                          index: "315I"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$t("SeaExport.GateIn"))
                                        )
                                      ]
                                    ),
                                    _c(
                                      "el-menu-item",
                                      {
                                        attrs: {
                                          no: "correct-315-VD",
                                          index: "315VD"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "SeaExport.VesselDeparturePOL"
                                            )
                                          )
                                        )
                                      ]
                                    ),
                                    _c(
                                      "el-menu-item",
                                      {
                                        attrs: {
                                          no: "correct-315-ALL",
                                          index: "315ALL"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$t("SeaExport.SendAll"))
                                        )
                                      ]
                                    )
                                  ],
                                  2
                                )
                              ],
                              2
                            ),
                            _c(
                              "el-submenu",
                              { attrs: { index: "delete" } },
                              [
                                _c("template", { slot: "title" }, [
                                  _vm._v(_vm._s(_vm.$t("SeaExport.Delete")))
                                ]),
                                _c(
                                  "el-submenu",
                                  { attrs: { index: "856" } },
                                  [
                                    _c("template", { slot: "title" }, [
                                      _vm._v(
                                        "856" +
                                          _vm._s(_vm.$t("SeaExport.Message"))
                                      )
                                    ]),
                                    _c(
                                      "el-menu-item",
                                      { attrs: { no: "34", index: "LTO" } },
                                      [_vm._v("LTO")]
                                    ),
                                    _c(
                                      "el-menu-item",
                                      { attrs: { no: "35", index: "CLP" } },
                                      [_vm._v("CLP")]
                                    )
                                  ],
                                  2
                                ),
                                _c(
                                  "el-submenu",
                                  { attrs: { index: "315" } },
                                  [
                                    _c("template", { slot: "title" }, [
                                      _vm._v(
                                        "315" +
                                          _vm._s(_vm.$t("SeaExport.Message"))
                                      )
                                    ]),
                                    _c(
                                      "el-menu-item",
                                      {
                                        attrs: {
                                          no: "delete-315-EE",
                                          index: "315EE"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$t("SeaExport.EmptyOut"))
                                        )
                                      ]
                                    ),
                                    _c(
                                      "el-menu-item",
                                      {
                                        attrs: {
                                          no: "delete-315-I",
                                          index: "315I"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$t("SeaExport.GateIn"))
                                        )
                                      ]
                                    ),
                                    _c(
                                      "el-menu-item",
                                      {
                                        attrs: {
                                          no: "delete-315-VD",
                                          index: "315VD"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "SeaExport.VesselDeparturePOL"
                                            )
                                          )
                                        )
                                      ]
                                    ),
                                    _c(
                                      "el-menu-item",
                                      {
                                        attrs: {
                                          no: "delete-315-ALL",
                                          index: "315ALL"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$t("SeaExport.SendAll"))
                                        )
                                      ]
                                    )
                                  ],
                                  2
                                )
                              ],
                              2
                            )
                          ],
                          2
                        ),
                        _c(
                          "el-menu-item",
                          {
                            attrs: {
                              no: "37",
                              index: "packing",
                              disabled: !_vm.btnStatus.packingBtn
                            }
                          },
                          [
                            _c(
                              "template",
                              { slot: "title" },
                              [
                                _c(
                                  "el-button",
                                  { attrs: { no: "38", type: "primary" } },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("SeaExport.AnnPackingList"))
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ],
                          2
                        ),
                        _c(
                          "el-submenu",
                          {
                            attrs: {
                              index: "preShipping",
                              disabled: !_vm.btnStatus.preShippingBtn
                            }
                          },
                          [
                            _c(
                              "template",
                              { slot: "title" },
                              [
                                _c(
                                  "el-button-group",
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          no: "39",
                                          type: "primary",
                                          size: "small"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("SeaExport.PreShippingBill")
                                          )
                                        )
                                      ]
                                    ),
                                    _c(
                                      "el-button",
                                      {
                                        staticClass: "attach-caret-button",
                                        attrs: { no: "40", type: "primary" }
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "el-icon-arrow-down"
                                        })
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _c(
                              "el-submenu",
                              { attrs: { index: "origin" } },
                              [
                                _c("template", { slot: "title" }, [
                                  _vm._v(_vm._s(_vm.$t("SeaExport.Original")))
                                ]),
                                _c(
                                  "el-menu-item",
                                  {
                                    attrs: {
                                      no: "410",
                                      index: "API",
                                      disabled: !(
                                        _vm.configMap.get(
                                          "PreplanEDIApiOpen"
                                        ) !== "0"
                                      )
                                    }
                                  },
                                  [_vm._v("API")]
                                ),
                                _c(
                                  "el-menu-item",
                                  {
                                    attrs: {
                                      no: "41",
                                      index: "FTP",
                                      disabled: _vm.isHZ
                                    }
                                  },
                                  [_vm._v("FTP")]
                                )
                              ],
                              2
                            ),
                            _c(
                              "el-submenu",
                              { attrs: { index: "correct" } },
                              [
                                _c("template", { slot: "title" }, [
                                  _vm._v(_vm._s(_vm.$t("SeaExport.Correct")))
                                ]),
                                _c(
                                  "el-menu-item",
                                  {
                                    attrs: {
                                      no: "42",
                                      index: "FTP",
                                      disabled: _vm.isHZ
                                    }
                                  },
                                  [_vm._v("FTP")]
                                ),
                                _c(
                                  "el-menu-item",
                                  {
                                    attrs: {
                                      no: "420",
                                      index: "API",
                                      disabled:
                                        !(
                                          _vm.configMap.get(
                                            "PreplanEDIApiOpen"
                                          ) !== "0"
                                        ) || _vm.isHZ
                                    }
                                  },
                                  [_vm._v("API")]
                                )
                              ],
                              2
                            ),
                            _c(
                              "el-submenu",
                              { attrs: { index: "delete" } },
                              [
                                _c("template", { slot: "title" }, [
                                  _vm._v(_vm._s(_vm.$t("FileHistory.Delete")))
                                ]),
                                _c(
                                  "el-menu-item",
                                  {
                                    attrs: {
                                      no: "43",
                                      index: "FTP",
                                      disabled: _vm.isHZ
                                    }
                                  },
                                  [_vm._v("FTP")]
                                ),
                                _c(
                                  "el-menu-item",
                                  {
                                    attrs: {
                                      no: "430",
                                      index: "API",
                                      disabled:
                                        !(
                                          _vm.configMap.get(
                                            "PreplanEDIApiOpen"
                                          ) !== "0"
                                        ) || _vm.isHZ
                                    }
                                  },
                                  [_vm._v("API")]
                                )
                              ],
                              2
                            )
                          ],
                          2
                        ),
                        _c(
                          "el-menu-item",
                          {
                            attrs: {
                              no: "47",
                              index: "shipping",
                              disabled: !_vm.btnStatus.shippingBtn
                            }
                          },
                          [
                            _c(
                              "template",
                              { slot: "title" },
                              [
                                _c(
                                  "el-button",
                                  { attrs: { no: "48", type: "primary" } },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("SeaExport.ShippingBill"))
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ],
                          2
                        ),
                        _c(
                          "el-submenu",
                          { attrs: { index: "afr" } },
                          [
                            _c(
                              "template",
                              { slot: "title" },
                              [
                                _c(
                                  "el-button-group",
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          no: "49",
                                          type: "primary",
                                          size: "small"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "SeaExport.Anti_terrorismShipping"
                                            )
                                          )
                                        )
                                      ]
                                    ),
                                    _c(
                                      "el-button",
                                      {
                                        staticClass: "attach-caret-button",
                                        attrs: { no: "50", type: "primary" }
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "el-icon-arrow-down"
                                        })
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _c(
                              "el-submenu",
                              { attrs: { index: "origin_ahr" } },
                              [
                                _c("template", { slot: "title" }, [
                                  _vm._v(
                                    _vm._s(_vm.$t("SeaExport.OriginalAHR"))
                                  )
                                ]),
                                _c(
                                  "el-menu-item",
                                  {
                                    attrs: {
                                      no: "51",
                                      index: "API",
                                      disabled:
                                        _vm.configMap.get(
                                          "afrSupplierConfiguration"
                                        ) !== "eFreight"
                                    }
                                  },
                                  [_vm._v("API")]
                                ),
                                _c(
                                  "el-menu-item",
                                  {
                                    attrs: {
                                      no: "52",
                                      index: "FTP",
                                      disabled:
                                        _vm.configMap.get(
                                          "afrSupplierConfiguration"
                                        ) !== "decarts" &&
                                        _vm.configMap.get(
                                          "afrSupplierConfiguration"
                                        ) !== "tradetech" &&
                                        _vm.configMap.get(
                                          "afrSupplierConfiguration"
                                        ) !== "other"
                                    }
                                  },
                                  [_vm._v("FTP")]
                                )
                              ],
                              2
                            ),
                            _c(
                              "el-submenu",
                              { attrs: { index: "add_chr" } },
                              [
                                _c("template", { slot: "title" }, [
                                  _vm._v(_vm._s(_vm.$t("SeaExport.AddChr")))
                                ]),
                                _c(
                                  "el-menu-item",
                                  {
                                    attrs: {
                                      no: "53",
                                      index: "API",
                                      disabled:
                                        _vm.configMap.get(
                                          "afrSupplierConfiguration"
                                        ) !== "eFreight"
                                    }
                                  },
                                  [_vm._v("API")]
                                ),
                                _c(
                                  "el-menu-item",
                                  {
                                    attrs: {
                                      no: "54",
                                      index: "FTP",
                                      disabled:
                                        _vm.configMap.get(
                                          "afrSupplierConfiguration"
                                        ) !== "decarts" &&
                                        _vm.configMap.get(
                                          "afrSupplierConfiguration"
                                        ) !== "tradetech" &&
                                        _vm.configMap.get(
                                          "afrSupplierConfiguration"
                                        ) !== "other"
                                    }
                                  },
                                  [_vm._v("FTP")]
                                )
                              ],
                              2
                            ),
                            _c(
                              "el-submenu",
                              { attrs: { index: "update_afr" } },
                              [
                                _c("template", { slot: "title" }, [
                                  _vm._v(_vm._s(_vm.$t("SeaExport.CorrectAFR")))
                                ]),
                                _c(
                                  "el-menu-item",
                                  {
                                    attrs: {
                                      no: "55",
                                      index: "API",
                                      disabled:
                                        _vm.configMap.get(
                                          "afrSupplierConfiguration"
                                        ) !== "eFreight"
                                    }
                                  },
                                  [_vm._v("API")]
                                ),
                                _c(
                                  "el-menu-item",
                                  {
                                    attrs: {
                                      no: "56",
                                      index: "FTP",
                                      disabled:
                                        _vm.configMap.get(
                                          "afrSupplierConfiguration"
                                        ) !== "decarts" &&
                                        _vm.configMap.get(
                                          "afrSupplierConfiguration"
                                        ) !== "tradetech" &&
                                        _vm.configMap.get(
                                          "afrSupplierConfiguration"
                                        ) !== "other"
                                    }
                                  },
                                  [_vm._v("FTP")]
                                )
                              ],
                              2
                            ),
                            _c(
                              "el-menu-item",
                              { attrs: { no: "57", index: "format_address" } },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("SeaExport.AddressFormatting"))
                                )
                              ]
                            )
                          ],
                          2
                        ),
                        _c(
                          "el-menu-item",
                          {
                            attrs: {
                              no: "58",
                              index: "clear",
                              disabled: !_vm.btnStatus.clearBtn
                            }
                          },
                          [
                            _c(
                              "template",
                              { slot: "title" },
                              [
                                _c(
                                  "el-button",
                                  { attrs: { type: "primary" } },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("SeaExport.CleanShipping"))
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ],
                          2
                        ),
                        _c(
                          "el-menu-item",
                          {
                            directives: [
                              {
                                name: "permission",
                                rawName: "v-permission",
                                value: ["button_EDI_suitcase"],
                                expression: "['button_EDI_suitcase']"
                              }
                            ],
                            attrs: { no: "59", index: "suitcase" }
                          },
                          [
                            _c(
                              "template",
                              { slot: "title" },
                              [
                                _c(
                                  "el-button",
                                  { attrs: { type: "primary" } },
                                  [_vm._v(_vm._s(_vm.$t("SeaExport.Suitcase")))]
                                )
                              ],
                              1
                            )
                          ],
                          2
                        ),
                        _vm.isHZ
                          ? _c(
                              "el-menu-item",
                              { attrs: { no: "125", index: "containerInfo" } },
                              [
                                _c(
                                  "template",
                                  { slot: "title" },
                                  [
                                    _c(
                                      "el-button",
                                      { attrs: { type: "primary" } },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("SeaExport.ContainerInfo")
                                          )
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ],
                              2
                            )
                          : _vm._e(),
                        _c(
                          "el-submenu",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value:
                                  _vm.configMap.get("isAllowToGoFreight") ===
                                  "1",
                                expression:
                                  "configMap.get('isAllowToGoFreight') === '1'"
                              }
                            ],
                            attrs: {
                              index: "freight",
                              disabled: !_vm.btnStatus.hasGoFreight
                            }
                          },
                          [
                            _c(
                              "template",
                              { slot: "title" },
                              [
                                _c(
                                  "el-button-group",
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          no: "60",
                                          type: "primary",
                                          size: "small"
                                        }
                                      },
                                      [_vm._v("GO FREIGHT")]
                                    ),
                                    _c(
                                      "el-button",
                                      {
                                        staticClass: "attach-caret-button",
                                        attrs: { no: "61", type: "primary" }
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "el-icon-arrow-down"
                                        })
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _c(
                              "el-menu-item",
                              { attrs: { no: "62", index: "send_freight" } },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("SeaExport.SendToGoFreight"))
                                )
                              ]
                            ),
                            _c(
                              "el-menu-item",
                              { attrs: { no: "63", index: "look_freight" } },
                              [_vm._v(_vm._s(_vm.$t("SeaExport.ViewSendLog")))]
                            )
                          ],
                          2
                        ),
                        _c(
                          "el-submenu",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value:
                                  _vm.configMap.get("openScfiDeclare") === "1",
                                expression:
                                  "configMap.get('openScfiDeclare') === '1'"
                              }
                            ],
                            attrs: { index: "scfi" }
                          },
                          [
                            _c(
                              "template",
                              { slot: "title" },
                              [
                                _c(
                                  "el-button-group",
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          no: "64",
                                          type: "primary",
                                          size: "small"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("SeaExport.ScfiDeclare")
                                          )
                                        )
                                      ]
                                    ),
                                    _c(
                                      "el-button",
                                      {
                                        staticClass: "attach-caret-button",
                                        attrs: { no: "65", type: "primary" }
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "el-icon-arrow-down"
                                        })
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _c(
                              "el-submenu",
                              {
                                attrs: {
                                  index: "booking_price",
                                  "popper-append-to-body": ""
                                }
                              },
                              [
                                _c("template", { slot: "title" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("SeaExport.BookingFreightRate")
                                    )
                                  )
                                ]),
                                _c(
                                  "el-menu-item",
                                  { attrs: { no: "66", index: "select_data" } },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "SeaExport.SelectedDataDeclaration"
                                        )
                                      )
                                    )
                                  ]
                                ),
                                _c(
                                  "el-menu-item",
                                  { attrs: { no: "67", index: "none_data" } },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "SeaExport.EmptySubmissionDeclaration"
                                        )
                                      )
                                    )
                                  ]
                                )
                              ],
                              2
                            ),
                            _c(
                              "el-submenu",
                              {
                                attrs: {
                                  index: "settle_price",
                                  "popper-append-to-body": ""
                                }
                              },
                              [
                                _c("template", { slot: "title" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("SeaExport.SettlementFreightRate")
                                    )
                                  )
                                ]),
                                _c(
                                  "el-menu-item",
                                  { attrs: { no: "68", index: "select_data" } },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "SeaExport.SelectedDataDeclaration"
                                        )
                                      )
                                    )
                                  ]
                                ),
                                _c(
                                  "el-menu-item",
                                  { attrs: { no: "69", index: "none_data" } },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "SeaExport.EmptySubmissionDeclaration"
                                        )
                                      )
                                    )
                                  ]
                                )
                              ],
                              2
                            ),
                            _c(
                              "el-menu-item",
                              { attrs: { no: "70", index: "record" } },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("SeaExport.DeclarationRecord"))
                                )
                              ]
                            )
                          ],
                          2
                        ),
                        !(
                          _vm.$checkPermission(["role_hideAllExports"]) &&
                          !_vm.$store.getters.isAdmin
                        )
                          ? _c(
                              "el-menu-item",
                              { attrs: { index: "export" } },
                              [
                                _c(
                                  "template",
                                  { slot: "title" },
                                  [
                                    _c(
                                      "el-button",
                                      { attrs: { no: "71", type: "primary" } },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$t("Payment.exportExcel"))
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ],
                              2
                            )
                          : _vm._e(),
                        _c(
                          "el-menu-item",
                          { attrs: { index: "history" } },
                          [
                            _c(
                              "template",
                              { slot: "title" },
                              [
                                _c(
                                  "el-button",
                                  { attrs: { no: "72", type: "primary" } },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("SeaExport.ViewHistory"))
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ],
                          2
                        ),
                        _c(
                          "el-submenu",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.tenantId === 100,
                                expression: "tenantId===100"
                              }
                            ],
                            attrs: { index: "electronicPacking" }
                          },
                          [
                            _c(
                              "template",
                              { slot: "title" },
                              [
                                _c(
                                  "el-button-group",
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          no: "73",
                                          type: "primary",
                                          size: "small"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "SeaExport.ElectronicPackingList"
                                            )
                                          )
                                        )
                                      ]
                                    ),
                                    _c(
                                      "el-button",
                                      {
                                        staticClass: "attach-caret-button",
                                        attrs: { no: "74", type: "primary" }
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "el-icon-arrow-down"
                                        })
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _c(
                              "el-menu-item",
                              {
                                attrs: { no: "75", index: "electronicPacking" }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("SeaExport.ElectronicPackingList")
                                  )
                                )
                              ]
                            ),
                            _c(
                              "el-menu-item",
                              { attrs: { no: "76", index: "history" } },
                              [_vm._v(_vm._s(_vm.$t("SeaExport.SendHistory")))]
                            )
                          ],
                          2
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ])
            ]),
            _c(
              "el-form",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.expandSearchForm,
                    expression: "expandSearchForm"
                  }
                ],
                staticStyle: { padding: "10px 0 0 5px" },
                attrs: {
                  inline: true,
                  "label-width": "85px",
                  "label-position": "left"
                }
              },
              [
                _c(
                  "div",
                  { staticClass: "search-form" },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SeaExport.WarehouseNo2") } },
                      [
                        _c("el-input", {
                          attrs: { no: "77" },
                          model: {
                            value: _vm.advancedSearchForm.warehouseNo,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.advancedSearchForm,
                                "warehouseNo",
                                $$v
                              )
                            },
                            expression: "advancedSearchForm.warehouseNo"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("Payment.mbl") } },
                      [
                        _c("el-input", {
                          attrs: { no: "78" },
                          model: {
                            value: _vm.advancedSearchForm.refNbr,
                            callback: function($$v) {
                              _vm.$set(_vm.advancedSearchForm, "refNbr", $$v)
                            },
                            expression: "advancedSearchForm.refNbr"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("Payment.containerNo") } },
                      [
                        _c("el-input", {
                          attrs: { no: "79" },
                          model: {
                            value: _vm.advancedSearchForm.containerNo,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.advancedSearchForm,
                                "containerNo",
                                $$v
                              )
                            },
                            expression: "advancedSearchForm.containerNo"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SeaExport.FileNo") } },
                      [
                        _c("el-input", {
                          attrs: { no: "80" },
                          model: {
                            value: _vm.advancedSearchForm.verificationNo,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.advancedSearchForm,
                                "verificationNo",
                                $$v
                              )
                            },
                            expression: "advancedSearchForm.verificationNo"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("Payment.bookingNo") } },
                      [
                        _c("el-input", {
                          attrs: { no: "81" },
                          model: {
                            value: _vm.advancedSearchForm.bookingNo,
                            callback: function($$v) {
                              _vm.$set(_vm.advancedSearchForm, "bookingNo", $$v)
                            },
                            expression: "advancedSearchForm.bookingNo"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: { label: _vm.$t("Payment.consignationCompany") }
                      },
                      [
                        _c("cargo-advance-select", {
                          attrs: {
                            no: "82",
                            filterable: "",
                            "select-type":
                              _vm.selectTypeNames.basic_data_Company,
                            "method-params": { customer: true },
                            "callback-method-type": "value",
                            "callback-params": { key: "customerId" },
                            "default-value":
                              _vm.advancedSearchForm.customerId || ""
                          },
                          on: { parentCallBack: _vm.getValueFromChild }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("queryJob.bookingAgent") } },
                      [
                        _c("cargo-advance-select", {
                          attrs: {
                            no: "83",
                            filterable: "",
                            "select-type":
                              _vm.selectTypeNames.basic_data_Company,
                            "method-params": { bookingAgent: true },
                            "callback-params": { key: "bookingAgent" },
                            "callback-method-type": "value",
                            "default-value":
                              _vm.advancedSearchForm.bookingAgent || ""
                          },
                          on: { parentCallBack: _vm.getValueFromChild }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("Payment.destinationAgent") } },
                      [
                        _c("cargo-advance-select", {
                          attrs: {
                            no: "84",
                            filterable: "",
                            "select-type":
                              _vm.selectTypeNames.basic_data_Company,
                            "callback-method-type": "value",
                            "tag-name": "englishName",
                            "method-params": { overseaAgent: true },
                            "callback-params": { key: "destinationAgent" },
                            "default-value":
                              _vm.advancedSearchForm.destinationAgent || ""
                          },
                          on: { parentCallBack: _vm.getValueFromChild }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SeaExport.ShippingCompany") } },
                      [
                        _c("cargo-advance-select", {
                          attrs: {
                            no: "85",
                            filterable: "",
                            "select-type":
                              _vm.selectTypeNames.basic_data_Company,
                            "method-params": { seaCmp: true },
                            "callback-method-type": "value",
                            "callback-params": { key: "carrierId" },
                            "default-value":
                              _vm.advancedSearchForm.carrierId || ""
                          },
                          on: { parentCallBack: _vm.getValueFromChild }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("Payment.itemNo") } },
                      [
                        _c("el-input", {
                          attrs: { no: "86" },
                          model: {
                            value: _vm.advancedSearchForm.poNo,
                            callback: function($$v) {
                              _vm.$set(_vm.advancedSearchForm, "poNo", $$v)
                            },
                            expression: "advancedSearchForm.poNo"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SeaExport.PortOfLoading") } },
                      [
                        _c("cargo-advance-select", {
                          attrs: {
                            no: "87",
                            filterable: "",
                            "select-type":
                              _vm.selectTypeNames.basic_data_Seaport,
                            "callback-method-type": "value",
                            "callback-params": { key: "loadingPortCode" },
                            "default-value":
                              _vm.advancedSearchForm.loadingPortCode || ""
                          },
                          on: { parentCallBack: _vm.getValueFromChild }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("Payment.portOfTransfer") } },
                      [
                        _c("cargo-advance-select", {
                          attrs: {
                            no: "88",
                            filterable: "",
                            "select-type":
                              _vm.selectTypeNames.basic_data_Seaport,
                            "callback-method-type": "value",
                            "callback-params": { key: "transferPortCode" },
                            "default-value":
                              _vm.advancedSearchForm.transferPortCode || ""
                          },
                          on: { parentCallBack: _vm.getValueFromChild }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SeaExport.PortOfDischarge") } },
                      [
                        _c("cargo-advance-select", {
                          attrs: {
                            no: "89",
                            filterable: "",
                            "select-type":
                              _vm.selectTypeNames.basic_data_Seaport,
                            "callback-method-type": "value",
                            "callback-params": { key: "destinationPort" },
                            "default-value":
                              _vm.advancedSearchForm.destinationPort || ""
                          },
                          on: { parentCallBack: _vm.getValueFromChild }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("queryJob.dateOfDeparture") } },
                      [
                        _c("el-date-picker", {
                          attrs: {
                            no: "90",
                            type: "daterange",
                            "value-format": "yyyy-MM-dd",
                            "start-placeholder": _vm.$t("Tool.BeginDate"),
                            "end-placeholder": _vm.$t("Project.EndtDate")
                          },
                          model: {
                            value: _vm.rangeDateETD,
                            callback: function($$v) {
                              _vm.rangeDateETD = $$v
                            },
                            expression: "rangeDateETD"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("Payment.businessReferenceNumber")
                        }
                      },
                      [
                        _c("el-input", {
                          attrs: { no: "91" },
                          model: {
                            value: _vm.advancedSearchForm.customerRefNo,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.advancedSearchForm,
                                "customerRefNo",
                                $$v
                              )
                            },
                            expression: "advancedSearchForm.customerRefNo"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("Message.Shipper") } },
                      [
                        _c("el-input", {
                          attrs: { no: "92" },
                          model: {
                            value: _vm.advancedSearchForm.shipper,
                            callback: function($$v) {
                              _vm.$set(_vm.advancedSearchForm, "shipper", $$v)
                            },
                            expression: "advancedSearchForm.shipper"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("Message.Consignee") } },
                      [
                        _c("el-input", {
                          attrs: { no: "93" },
                          model: {
                            value: _vm.advancedSearchForm.consignee,
                            callback: function($$v) {
                              _vm.$set(_vm.advancedSearchForm, "consignee", $$v)
                            },
                            expression: "advancedSearchForm.consignee"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "SO NO" } },
                      [
                        _c("el-input", {
                          attrs: { no: "94" },
                          model: {
                            value: _vm.advancedSearchForm.soNo,
                            callback: function($$v) {
                              _vm.$set(_vm.advancedSearchForm, "soNo", $$v)
                            },
                            expression: "advancedSearchForm.soNo"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SeaExport.DateOfArrival") } },
                      [
                        _c("el-date-picker", {
                          attrs: {
                            no: "95",
                            type: "daterange",
                            "value-format": "yyyy-MM-dd",
                            "start-placeholder": _vm.$t("Tool.BeginDate"),
                            "end-placeholder": _vm.$t("Project.EndtDate")
                          },
                          model: {
                            value: _vm.rangeDateETA,
                            callback: function($$v) {
                              _vm.rangeDateETA = $$v
                            },
                            expression: "rangeDateETA"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("queryJob.shippingCompanyContractNo")
                        }
                      },
                      [
                        _c("el-input", {
                          attrs: { no: "96" },
                          model: {
                            value: _vm.advancedSearchForm.scNo,
                            callback: function($$v) {
                              _vm.$set(_vm.advancedSearchForm, "scNo", $$v)
                            },
                            expression: "advancedSearchForm.scNo"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("Payment.vessel") } },
                      [
                        _c("cargo-advance-select", {
                          attrs: {
                            no: "97",
                            filterable: "",
                            "select-type":
                              _vm.selectTypeNames.basic_data_Vessel,
                            "callback-method-type": "value",
                            "callback-params": { key: "vessel" },
                            "default-value": _vm.advancedSearchForm.vessel || ""
                          },
                          on: { parentCallBack: _vm.getValueFromChild }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("Payment.voyage") } },
                      [
                        _c("el-input", {
                          attrs: { no: "98" },
                          model: {
                            value: _vm.advancedSearchForm.voyageFlight,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.advancedSearchForm,
                                "voyageFlight",
                                $$v
                              )
                            },
                            expression: "advancedSearchForm.voyageFlight"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("Payment.billNo") } },
                      [
                        _c("el-input", {
                          attrs: { no: "99" },
                          model: {
                            value: _vm.advancedSearchForm.billingNo,
                            callback: function($$v) {
                              _vm.$set(_vm.advancedSearchForm, "billingNo", $$v)
                            },
                            expression: "advancedSearchForm.billingNo"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SeaExport.LoadingDate") } },
                      [
                        _c("el-date-picker", {
                          attrs: {
                            no: "100",
                            type: "daterange",
                            "value-format": "yyyy-MM-dd",
                            "start-placeholder": _vm.$t("Tool.BeginDate"),
                            "end-placeholder": _vm.$t("Project.EndtDate")
                          },
                          model: {
                            value: _vm.rangeDateLoadingDate,
                            callback: function($$v) {
                              _vm.rangeDateLoadingDate = $$v
                            },
                            expression: "rangeDateLoadingDate"
                          }
                        })
                      ],
                      1
                    ),
                    _c("el-form-item", { staticClass: "form-item-300" }, [
                      _c(
                        "div",
                        { staticStyle: { display: "flex" } },
                        [
                          _c("el-checkbox", {
                            attrs: { no: "101", label: "AMS" },
                            model: {
                              value: _vm.advancedSearchForm.ams,
                              callback: function($$v) {
                                _vm.$set(_vm.advancedSearchForm, "ams", $$v)
                              },
                              expression: "advancedSearchForm.ams"
                            }
                          }),
                          _c("el-checkbox", {
                            attrs: { no: "102", label: "VGM" },
                            model: {
                              value: _vm.advancedSearchForm.vgm,
                              callback: function($$v) {
                                _vm.$set(_vm.advancedSearchForm, "vgm", $$v)
                              },
                              expression: "advancedSearchForm.vgm"
                            }
                          }),
                          _c("el-checkbox", {
                            attrs: {
                              no: "103",
                              label: _vm.$t(
                                "SeaExport.IncludingSCFIFreightRate"
                              )
                            },
                            model: {
                              value: _vm.advancedSearchForm.contain,
                              callback: function($$v) {
                                _vm.$set(_vm.advancedSearchForm, "contain", $$v)
                              },
                              expression: "advancedSearchForm.contain"
                            }
                          }),
                          _c("el-checkbox", {
                            attrs: {
                              no: "104",
                              label: _vm.$t("SeaExport.SCFIDesignatedBoxType")
                            },
                            model: {
                              value: _vm.advancedSearchForm.appoint,
                              callback: function($$v) {
                                _vm.$set(_vm.advancedSearchForm, "appoint", $$v)
                              },
                              expression: "advancedSearchForm.appoint"
                            }
                          })
                        ],
                        1
                      )
                    ]),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("queryJob.FLCLType") } },
                      [
                        _c(
                          "el-select",
                          {
                            attrs: {
                              no: "105",
                              placeholder: _vm.$t("common.tips.pleaseChoose"),
                              multiple: "",
                              "collapse-tags": "",
                              clearable: ""
                            },
                            model: {
                              value: _vm.advancedSearchForm.containerLoadTypes,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.advancedSearchForm,
                                  "containerLoadTypes",
                                  $$v
                                )
                              },
                              expression:
                                "advancedSearchForm.containerLoadTypes"
                            }
                          },
                          _vm._l(_vm.containerLoadTypes, function(item, index) {
                            return _c("el-option", {
                              key: index,
                              attrs: {
                                label: _vm.isZh
                                  ? item.chineseName
                                  : item.englishName,
                                value: item.code
                              }
                            })
                          }),
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SeaExport.LocalService") } },
                      [
                        _c(
                          "el-select",
                          {
                            attrs: {
                              no: "106",
                              placeholder: _vm.$t("common.tips.pleaseChoose"),
                              multiple: "",
                              "collapse-tags": "",
                              clearable: ""
                            },
                            model: {
                              value: _vm.advancedSearchForm.stuffingTypes,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.advancedSearchForm,
                                  "stuffingTypes",
                                  $$v
                                )
                              },
                              expression: "advancedSearchForm.stuffingTypes"
                            }
                          },
                          _vm._l(_vm.localServices, function(item) {
                            return _c("el-option", {
                              key: item.code,
                              attrs: {
                                label: _vm.isZh
                                  ? item.chineseName
                                  : item.englishName,
                                value: item.code
                              }
                            })
                          }),
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("Payment.solicitationType") } },
                      [
                        _c(
                          "el-select",
                          {
                            attrs: {
                              no: "107",
                              placeholder: _vm.$t("common.tips.pleaseChoose")
                            },
                            model: {
                              value: _vm.advancedSearchForm.cargoSource,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.advancedSearchForm,
                                  "cargoSource",
                                  $$v
                                )
                              },
                              expression: "advancedSearchForm.cargoSource"
                            }
                          },
                          _vm._l(_vm.solicitationTypes, function(item) {
                            return _c("el-option", {
                              key: item.code,
                              attrs: {
                                label: _vm.isZh
                                  ? item.chineseName
                                  : item.englishName,
                                value: item.code
                              }
                            })
                          }),
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("FileHistory.createdDate") } },
                      [
                        _c("el-date-picker", {
                          attrs: {
                            no: "108",
                            type: "daterange",
                            "value-format": "yyyy-MM-dd",
                            "start-placeholder": _vm.$t("Tool.BeginDate"),
                            "end-placeholder": _vm.$t("Project.EndtDate")
                          },
                          model: {
                            value: _vm.rangeDateDateCreated,
                            callback: function($$v) {
                              _vm.rangeDateDateCreated = $$v
                            },
                            expression: "rangeDateDateCreated"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { staticClass: "form-item-300" },
                      [
                        _c("el-checkbox", {
                          attrs: {
                            no: "109",
                            label: _vm.$t("SeaExport.ShutOut")
                          },
                          model: {
                            value: _vm.advancedSearchForm.shutOut,
                            callback: function($$v) {
                              _vm.$set(_vm.advancedSearchForm, "shutOut", $$v)
                            },
                            expression: "advancedSearchForm.shutOut"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SeaExport.CargoType") } },
                      [
                        _c("cargo-advance-select", {
                          attrs: {
                            no: "110",
                            filterable: "",
                            cache: "",
                            "fixed-options": [
                              { code: "", chineseName: _vm.$t("SeaExport.All") }
                            ],
                            "select-type":
                              _vm.selectTypeNames.basic_data_CargoType,
                            "method-params": { sea: true },
                            fields: ["chineseName"],
                            "tag-value": "code",
                            "default-value": _vm.advancedSearchForm.cargoType,
                            "callback-method-type": "value",
                            "callback-params": { key: "cargoType" }
                          },
                          on: { parentCallBack: _vm.getValueFromChild }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("SeaExport.MBLTransportationClause")
                        }
                      },
                      [
                        _c("cargo-advance-select", {
                          attrs: {
                            no: "111",
                            cache: "",
                            "fixed-options": [
                              { code: "", name: _vm.$t("SeaExport.All") }
                            ],
                            "select-type":
                              _vm.selectTypeNames.basic_data_ShippingTerm,
                            "default-value": _vm.advancedSearchForm.freightTerm,
                            "callback-method-type": "value",
                            "callback-params": { key: "freightTerm" },
                            "options-width": "180px"
                          },
                          on: { parentCallBack: _vm.getValueFromChild }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SeaExport.PortOfDischarge") } },
                      [
                        _c("cargo-advance-select", {
                          attrs: {
                            no: "112",
                            filterable: "",
                            multiple: "",
                            "select-type":
                              _vm.selectTypeNames.basic_data_Seaport,
                            "callback-method-type": "value",
                            "callback-params": { key: "dischargingPortCodes" },
                            "default-multiple-value":
                              _vm.advancedSearchForm.dischargingPortCodes || []
                          },
                          on: { parentCallBack: _vm.getValueFromChild }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("Payment.operationDate") } },
                      [
                        _c("el-date-picker", {
                          attrs: {
                            no: "113",
                            type: "daterange",
                            "value-format": "yyyy-MM-dd",
                            "start-placeholder": _vm.$t("Tool.BeginDate"),
                            "end-placeholder": _vm.$t("Project.EndtDate")
                          },
                          model: {
                            value: _vm.rangeDateCustomsDate,
                            callback: function($$v) {
                              _vm.rangeDateCustomsDate = $$v
                            },
                            expression: "rangeDateCustomsDate"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("SeaExport.ActualDateOfLeavingBerth")
                        }
                      },
                      [
                        _c("el-date-picker", {
                          attrs: {
                            no: "114",
                            type: "daterange",
                            "value-format": "yyyy-MM-dd",
                            "start-placeholder": _vm.$t("Tool.BeginDate"),
                            "end-placeholder": _vm.$t("Project.EndtDate")
                          },
                          model: {
                            value: _vm.rangeDateActualUnBerthPlanDate,
                            callback: function($$v) {
                              _vm.rangeDateActualUnBerthPlanDate = $$v
                            },
                            expression: "rangeDateActualUnBerthPlanDate"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: { label: _vm.$t("CargoMsg.Cargo_BookingState") }
                      },
                      [
                        _c("cargo-advance-select", {
                          attrs: {
                            no: "bookingState",
                            filterable: "",
                            multiple: "",
                            "default-multiple-value":
                              _vm.advancedSearchForm.newBookingStates || [],
                            cache: false,
                            "tag-name": "chineseName",
                            "tag-value": "code",
                            "filter-tag-names": ["code", "chineseName"],
                            "static-options": _vm.JOB_BOOKING_STATES
                          },
                          on: {
                            parentCallBack: function(p) {
                              _vm.advancedSearchForm.newBookingStates = p.value
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SeaExport.OrderChannels") } },
                      [
                        _c("el-input", {
                          attrs: { no: "salesChannel" },
                          model: {
                            value: _vm.advancedSearchForm.salesChannel,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.advancedSearchForm,
                                "salesChannel",
                                $$v
                              )
                            },
                            expression: "advancedSearchForm.salesChannel"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("CargoMsg.Cargo_BookingSendMethod")
                        }
                      },
                      [
                        _c("cargo-advance-select", {
                          attrs: {
                            no: "bookingSendMethod",
                            filterable: "",
                            "default-value":
                              _vm.advancedSearchForm.bookingSendMethod,
                            cache: false,
                            "tag-name": "chineseName",
                            "tag-value": "code",
                            "filter-tag-names": ["code", "chineseName"],
                            "static-options": _vm.BOOKING_SEND_METHODS
                          },
                          on: {
                            parentCallBack: function(p) {
                              _vm.advancedSearchForm.bookingSendMethod = p.value
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("CargoMsg.Cargo_BookingTransportMode")
                        }
                      },
                      [
                        _c("cargo-advance-select", {
                          attrs: {
                            no: "bookingTransportMode",
                            filterable: "",
                            "default-value":
                              _vm.advancedSearchForm.bookingTransportMode,
                            cache: false,
                            "tag-name": "chineseName",
                            "tag-value": "code",
                            "filter-tag-names": ["code", "chineseName"],
                            "static-options": _vm.TRANSPORT_MODES
                          },
                          on: {
                            parentCallBack: function(p) {
                              _vm.advancedSearchForm.bookingTransportMode =
                                p.value
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("CargoMsg.Cargo_OriginBookingState")
                        }
                      },
                      [
                        _c("el-input", {
                          attrs: { no: "originBookingState" },
                          model: {
                            value: _vm.advancedSearchForm.originBookingState,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.advancedSearchForm,
                                "originBookingState",
                                $$v
                              )
                            },
                            expression: "advancedSearchForm.originBookingState"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "search-form-bottom" },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("Payment.sales"),
                          "label-width": "36px"
                        }
                      },
                      [
                        _c("cargo-advance-select", {
                          attrs: {
                            no: "115",
                            filterable: "",
                            "select-type": _vm.selectTypeNames.basic_data_User,
                            url: _vm.url.sys.getUsersByPrivilegeDetail,
                            cache: false,
                            "method-params": {
                              officeId: null,
                              category: "role",
                              shape: "sales"
                            },
                            "callback-params": { key: "sales" },
                            "callback-method-type": "value",
                            "default-value": _vm.advancedSearchForm.sales || ""
                          },
                          on: { parentCallBack: _vm.getValueFromChild }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("FileHistory.operation"),
                          "label-width": "55px"
                        }
                      },
                      [
                        _c("cargo-advance-select", {
                          attrs: {
                            no: "116",
                            filterable: "",
                            "select-type": _vm.selectTypeNames.basic_data_User,
                            url: _vm.url.sys.getUsersByPrivilegeDetail,
                            cache: false,
                            "method-params": {
                              officeId: _vm.currentOfficeId,
                              category: "role",
                              shape: "op"
                            },
                            "callback-params": { key: "op" },
                            "callback-method-type": "value",
                            "default-value": _vm.advancedSearchForm.op || ""
                          },
                          on: { parentCallBack: _vm.getValueFromChild }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("Payment.customerService"),
                          "label-width": "55px"
                        }
                      },
                      [
                        _c("cargo-advance-select", {
                          attrs: {
                            no: "117",
                            filterable: "",
                            "select-type": _vm.selectTypeNames.basic_data_User,
                            url: _vm.url.sys.getUsersByPrivilegeDetail,
                            cache: false,
                            "method-params": {
                              officeId: null,
                              category: "role",
                              shape: "csr"
                            },
                            "callback-params": { key: "csr" },
                            "callback-method-type": "value",
                            "default-value": _vm.advancedSearchForm.csr || ""
                          },
                          on: { parentCallBack: _vm.getValueFromChild }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("queryJob.Documents"),
                          "label-width": "65px"
                        }
                      },
                      [
                        _c("cargo-advance-select", {
                          attrs: {
                            no: "118",
                            filterable: "",
                            "select-type": _vm.selectTypeNames.basic_data_User,
                            url: _vm.url.sys.getUsersByPrivilegeDetail,
                            cache: false,
                            "method-params": {
                              officeId: null,
                              category: "role",
                              shape: "doc"
                            },
                            "callback-params": { key: "doc" },
                            "callback-method-type": "value",
                            "default-value": _vm.advancedSearchForm.doc || ""
                          },
                          on: { parentCallBack: _vm.getValueFromChild }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("queryJob.route"),
                          "label-width": "36px"
                        }
                      },
                      [
                        _c("cargo-advance-select", {
                          attrs: {
                            no: "119",
                            filterable: "",
                            "select-type": _vm.selectTypeNames.basic_data_User,
                            url: _vm.url.sys.getUsersByPrivilegeDetail,
                            cache: false,
                            "method-params": {
                              officeId: null,
                              category: "role",
                              shape: "sealine"
                            },
                            "callback-params": { key: "planner" },
                            "callback-method-type": "value",
                            "default-value":
                              _vm.advancedSearchForm.planner || ""
                          },
                          on: { parentCallBack: _vm.getValueFromChild }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("Payment.businessStatus"),
                          "label-width": "60px"
                        }
                      },
                      [
                        _c(
                          "el-select",
                          {
                            attrs: {
                              no: "120",
                              placeholder: _vm.$t("common.tips.pleaseChoose"),
                              multiple: "",
                              "collapse-tags": "",
                              clearable: ""
                            },
                            model: {
                              value: _vm.advancedSearchForm.states,
                              callback: function($$v) {
                                _vm.$set(_vm.advancedSearchForm, "states", $$v)
                              },
                              expression: "advancedSearchForm.states"
                            }
                          },
                          _vm._l(_vm.businessStatuses, function(item) {
                            return _c("el-option", {
                              key: item.code,
                              attrs: {
                                label: _vm.isZh
                                  ? item.chineseName
                                  : item.englishName,
                                value: item.code
                              }
                            })
                          }),
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("queryJob.IncoTerm"),
                          "label-width": "60px"
                        }
                      },
                      [
                        _c("cargo-advance-select", {
                          attrs: {
                            no: "121",
                            cache: "",
                            multiple: "",
                            "select-type":
                              _vm.selectTypeNames.basic_data_IncoTerm,
                            "callback-method-type": "value",
                            "callback-params": { key: "incoTermList" },
                            "options-width": "120px",
                            "default-multiple-value":
                              _vm.advancedSearchForm.incoTermList || []
                          },
                          on: { parentCallBack: _vm.getValueFromChild }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        staticClass: "form-item-150",
                        attrs: {
                          label: _vm.$t("queryJob.masterBLFreightTerm"),
                          "label-width": "85px"
                        }
                      },
                      [
                        _c("cargo-advance-select", {
                          attrs: {
                            no: "122",
                            cache: "",
                            fields: ["name"],
                            multiple: "",
                            "select-type":
                              _vm.selectTypeNames.basic_data_PaymentTerm,
                            "callback-method-type": "value",
                            "callback-params": { key: "paymentTermMBLs" },
                            "options-width": "180px",
                            "default-multiple-value":
                              _vm.advancedSearchForm.paymentTermMBLs || []
                          },
                          on: { parentCallBack: _vm.getValueFromChild }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        staticClass: "form-item-525",
                        attrs: {
                          label: _vm.$t("Message.StateQuery"),
                          "label-width": "85px"
                        }
                      },
                      [
                        _c(
                          "div",
                          { staticStyle: { display: "flex" } },
                          [
                            _c("el-input", {
                              attrs: {
                                no: "123",
                                value: _vm.stateQueryTxtContent,
                                size: "mini",
                                readonly: "",
                                placeholder: _vm.$t(
                                  "Message.DoubleClickToSelectState"
                                )
                              },
                              nativeOn: {
                                dblclick: function($event) {
                                  return _vm.toShowEdiStateQueryDialog()
                                }
                              }
                            }),
                            _c(
                              "el-button",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: !!_vm.stateQueryTxtContent,
                                    expression: "!!stateQueryTxtContent"
                                  }
                                ],
                                attrs: { size: "mini" },
                                on: {
                                  click: function($event) {
                                    return _vm.toClearEdiStateQuery()
                                  }
                                }
                              },
                              [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Clear")))]
                            )
                          ],
                          1
                        )
                      ]
                    ),
                    _c(
                      "el-form-item",
                      {
                        staticClass: "form-item-200",
                        attrs: {
                          label: _vm.$t("CargoMsg.Cargo_CustomJobType"),
                          "label-width": "100px"
                        }
                      },
                      [
                        _c("cargo-advance-select", {
                          attrs: {
                            no: "124",
                            cache: "",
                            multiple: "",
                            "select-type":
                              _vm.selectTypeNames.basic_data_CutomJobType,
                            "data-filter-function": function(p) {
                              return p.type === "SE"
                            },
                            "callback-method-type": "value",
                            "callback-params": { key: "customJobType" },
                            "options-width": "180px",
                            "default-multiple-value":
                              _vm.advancedSearchForm.customJobType || []
                          },
                          on: { parentCallBack: _vm.getValueFromChild }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("CargoMsg.Cargo_SendToExchangeTime"),
                          "label-width": "100px"
                        }
                      },
                      [
                        _c("el-date-picker", {
                          staticStyle: { width: "200px" },
                          attrs: {
                            no: "90",
                            type: "daterange",
                            "value-format": "yyyy-MM-dd",
                            "start-placeholder": _vm.$t("Tool.BeginDate"),
                            "end-placeholder": _vm.$t("Project.EndtDate")
                          },
                          model: {
                            value: _vm.rangeSendToExchangeDate,
                            callback: function($$v) {
                              _vm.rangeSendToExchangeDate = $$v
                            },
                            expression: "rangeSendToExchangeDate"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            ),
            _c(
              "div",
              { staticClass: "section grid-wrapper" },
              [
                _vm.oneKeyBookingEnable
                  ? _c(
                      "div",
                      {
                        staticClass: "booking-state-statistic",
                        staticStyle: {
                          display: "flex",
                          "align-self": "flex-end",
                          padding: "8px"
                        }
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(_vm.$t("CargoMsg.Cargo_CurrentlyBooking"))
                          )
                        ]),
                        _c(
                          "span",
                          {
                            staticStyle: {
                              cursor: "pointer",
                              "text-decoration": "underline",
                              color: "blue"
                            },
                            on: {
                              click: function($event) {
                                return _vm.statisticClick(
                                  _vm.JOB_BOOKING_STATE_BOOKING.code
                                )
                              }
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.ediBookingStateStatisticsVo.bookingCount
                              )
                            )
                          ]
                        ),
                        _c(
                          "span",
                          { staticStyle: { "margin-right": "10px" } },
                          [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Pcst")))]
                        ),
                        _c("span", [
                          _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_SendSuccess2")))
                        ]),
                        _c(
                          "span",
                          {
                            staticStyle: {
                              cursor: "pointer",
                              "text-decoration": "underline",
                              color: "blue"
                            },
                            on: {
                              click: function($event) {
                                return _vm.statisticClick(
                                  _vm.JOB_BOOKING_STATE_BOOKING_SEND_SUCCESS
                                    .code
                                )
                              }
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.ediBookingStateStatisticsVo
                                  .bookingSendSuccessCount
                              )
                            )
                          ]
                        ),
                        _c(
                          "span",
                          { staticStyle: { "margin-right": "10px" } },
                          [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Pcst")))]
                        ),
                        _c("span", [
                          _vm._v(
                            _vm._s(_vm.$t("CargoMsg.Cargo_SendFail") + ":")
                          )
                        ]),
                        _c(
                          "span",
                          {
                            staticStyle: {
                              cursor: "pointer",
                              "text-decoration": "underline",
                              color: "red"
                            },
                            on: {
                              click: function($event) {
                                return _vm.statisticClick(
                                  _vm.JOB_BOOKING_STATE_BOOKING_SEND_FAIL.code
                                )
                              }
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(
                                Number(
                                  _vm.ediBookingStateStatisticsVo
                                    .callEdiFailCount
                                ) +
                                  Number(
                                    _vm.ediBookingStateStatisticsVo
                                      .validFailCount
                                  ) +
                                  Number(
                                    _vm.ediBookingStateStatisticsVo
                                      .templateMatchFailCount
                                  )
                              )
                            )
                          ]
                        ),
                        _c(
                          "span",
                          { staticStyle: { "margin-right": "10px" } },
                          [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Pcst")))]
                        )
                      ]
                    )
                  : _vm._e(),
                _c("cargo-ag-grid", {
                  attrs: {
                    "config-module": "140701",
                    "grid-options": _vm.gridOptions,
                    "column-defs": _vm.columnDefs,
                    "row-data": _vm.rowData,
                    "show-selected-color": false
                  },
                  on: {
                    gridReady: function(params) {
                      _vm.gridApi = params.api
                    }
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "pagination-wrapper" },
              [
                _c("cargo-pagination", {
                  attrs: {
                    "config-module": "140701",
                    page: _vm.searchConditions.pageNum,
                    limit: _vm.searchConditions.pageSize,
                    total: _vm.total
                  },
                  on: {
                    "update:page": function($event) {
                      return _vm.$set(_vm.searchConditions, "pageNum", $event)
                    },
                    "update:limit": function($event) {
                      return _vm.$set(_vm.searchConditions, "pageSize", $event)
                    },
                    pagination: _vm.pageChanged
                  }
                })
              ],
              1
            )
          ],
          1
        )
      ]),
      _c("input", {
        ref: "importFile",
        staticStyle: { display: "none" },
        attrs: { type: "file", accept: ".pms" },
        on: { change: _vm.onImportFile }
      }),
      _c("cargo-template-selector-dialog", {
        attrs: {
          visible: _vm.templateSelectorDialog.visible,
          ctx: _vm.templateSelectorDialog.cxt,
          category: _vm.templateSelectorDialog.category,
          data: _vm.templateSelectorDialog.data
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.templateSelectorDialog, "visible", $event)
          }
        }
      }),
      _c("dialog-selector", {
        attrs: {
          visible: _vm.selectorDialog.visible,
          title: _vm.selectorDialog.title,
          "row-data": _vm.selectorDialog.rowData
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.selectorDialog, "visible", $event)
          },
          selected: _vm.getEDICallback
        }
      }),
      _c("message-preview-dialog", {
        attrs: {
          visible: _vm.messagePreviewDialog.visible,
          params: _vm.messagePreviewDialog.params
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.messagePreviewDialog, "visible", $event)
          },
          uploadSuccess: _vm.uploadSuccess
        }
      }),
      _c("show-history-dialog", {
        attrs: {
          visible: _vm.showHistoryDialog.visible,
          params: _vm.showHistoryDialog.params
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.showHistoryDialog, "visible", $event)
          }
        }
      }),
      _c("multi-seg-num-rules-dialog", {
        attrs: { visible: _vm.multiSegNumRulesDialog.visible },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.multiSegNumRulesDialog, "visible", $event)
          },
          callback: _vm.multiSegNumRulesCallback
        }
      }),
      _c("declarate-record-dialog", {
        attrs: {
          visible: _vm.declarateRecordDialog.visible,
          params: _vm.declarateRecordDialog.params
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.declarateRecordDialog, "visible", $event)
          }
        }
      }),
      _c("address-format-dialog", {
        attrs: {
          visible: _vm.addressFormatDialog.visible,
          "show-grid": true,
          params: _vm.addressFormatDialog.params
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.addressFormatDialog, "visible", $event)
          }
        }
      }),
      _c("econtainer-history", {
        attrs: {
          visible: _vm.econtainerHistoryDialog.visible,
          params: _vm.econtainerHistoryDialog.params
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.econtainerHistoryDialog, "visible", $event)
          }
        }
      }),
      _c("error-log-dialog", {
        attrs: {
          visible: _vm.errorLogDialog.visible,
          "error-log": _vm.errorLogDialog.errorLog
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.errorLogDialog, "visible", $event)
          }
        }
      }),
      _c("edi-scfi-prompt-dialog", {
        attrs: {
          visible: _vm.ediScfiPromptDialog.visible,
          params: _vm.ediScfiPromptDialog.params
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.ediScfiPromptDialog, "visible", $event)
          }
        }
      }),
      _c("go-freight-log-dialog", {
        attrs: {
          visible: _vm.goFreightLogDialog.visible,
          "job-uuid": _vm.goFreightLogDialog.jobUuid
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.goFreightLogDialog, "visible", $event)
          }
        }
      }),
      _c("api-popup", {
        attrs: {
          visible: _vm.apiPopup.visible,
          title: _vm.apiPopup.title,
          "interface-type": _vm.apiPopup.interfaceType,
          "interface-array": _vm.apiPopup.interfaceArray
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.apiPopup, "visible", $event)
          },
          selectedApi: _vm.apiPopup.callback
        }
      }),
      _vm.ediStateQueryDialog.isCreate
        ? _c("edi-state-query-dialog", {
            attrs: {
              visible: _vm.ediStateQueryDialog.visible,
              title: _vm.ediStateQueryDialog.title,
              value: _vm.ediStateQueryDialog.value
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.ediStateQueryDialog, "visible", $event)
              },
              callback: _vm.ediStateQueryDialog.callback
            }
          })
        : _vm._e(),
      _c("cargo-doc-extend", {
        attrs: {
          visible: _vm.cargoDocExtendDialog.visible,
          title: _vm.cargoDocExtendDialog.title,
          "job-uuid": _vm.cargoDocExtendDialog.jobUuid,
          "carrier-id": _vm.cargoDocExtendDialog.carrierId
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.cargoDocExtendDialog, "visible", $event)
          }
        }
      }),
      _c("one-key-booking", {
        ref: "oneKeyBooking",
        attrs: { visible: _vm.oneKeyBooking.visible },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.oneKeyBooking, "visible", $event)
          },
          refresh: function() {
            if (_vm.expandSearchForm || _vm.paginationChanged) {
              _vm.fetchData()
            } else {
              _vm.queryBookingStateStatistics()
            }
          }
        }
      }),
      _c("booking-fail-dialog", {
        attrs: {
          visible: _vm.bookingFailDialog.visible,
          "select-data": _vm.bookingFailDialog.selectData
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.bookingFailDialog, "visible", $event)
          },
          refresh: function() {
            if (
              _vm.expandSearchForm ||
              _vm.paginationChanged ||
              _vm.searchConditions.jobNo
            ) {
              _vm.fetchData()
            } else {
              _vm.queryBookingStateStatistics()
            }
          }
        }
      }),
      _vm.checkingWindow.visible
        ? _c("checking-window", {
            attrs: {
              visible: _vm.checkingWindow.visible,
              lob: _vm.checkingWindow.lob,
              job: _vm.checkingWindow.job,
              "check-node": _vm.checkingWindow.checkNode,
              "call-back": _vm.checkingWindow.callBack
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.checkingWindow, "visible", $event)
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }